import React from 'react'
import { UseResearchDetailType } from './uploadDocType'

const useResearchDetail = (props: UseResearchDetailType) => {
    const [isExpanded, setExpanded] = React.useState<boolean>(true)
    const [docLst, setDocLst] = React.useState<string[]>()

    const handleClickAccordionChange = (isExpanded: boolean) => {
        setExpanded(isExpanded)
    }
    const onChangeUpload = async (fileList: Array<any>, mainTopicID: number) => {}
    return { isExpanded, docLst, onClickAccordionChange: handleClickAccordionChange, onChangeUpload }
}

export default useResearchDetail
